module.exports = "/_next/static/images/Error-3a53f48c83bad5e55cdb1c55484d9f19.png";